import type {
  SalesOrderStatus,
  SalesOutboundStatus,
  SalesRequestStatus,
} from '@app/api/purchase-service-sales';

export type TagSeverity =
  | 'success'
  | 'info'
  | 'warn'
  | 'danger'
  | 'secondary'
  | 'contrast';

export const SALES_REQUEST_STATUS_SEVERITY: Record<
  SalesRequestStatus,
  TagSeverity
> = {
  PENDING: 'warn',
  APPROVED: 'success',
  REJECTED: 'danger',
};

export const SALES_ORDER_STATUS_SEVERITY: Record<SalesOrderStatus, TagSeverity> =
  {
    PENDING: 'warn',
    APPROVED: 'info',
    RELEASED: 'contrast',
    COMPLETED: 'success',
    CANCELLED: 'secondary',
    REJECTED: 'danger',
  };

export const SALES_OUTBOUND_STATUS_SEVERITY: Record<
  SalesOutboundStatus,
  TagSeverity
> = {
  PENDING: 'warn',
  SHIPPED: 'success',
};

/** Safe for Angular templates (status may be typed loosely from the table row). */
export function salesRequestSeverity(
  status: string | null | undefined,
): TagSeverity {
  if (!status) {
    return 'secondary';
  }
  return SALES_REQUEST_STATUS_SEVERITY[status as SalesRequestStatus] ?? 'secondary';
}

export function salesOrderSeverity(
  status: string | null | undefined,
): TagSeverity {
  if (!status) {
    return 'secondary';
  }
  return SALES_ORDER_STATUS_SEVERITY[status as SalesOrderStatus] ?? 'secondary';
}

export function salesOutboundSeverity(
  status: string | null | undefined,
): TagSeverity {
  if (!status) {
    return 'secondary';
  }
  return (
    SALES_OUTBOUND_STATUS_SEVERITY[status as SalesOutboundStatus] ?? 'secondary'
  );
}

export const SALES_REQUEST_STATUSES: SalesRequestStatus[] = [
  'PENDING',
  'APPROVED',
  'REJECTED',
];

export const SALES_ORDER_STATUSES: SalesOrderStatus[] = [
  'PENDING',
  'APPROVED',
  'RELEASED',
  'COMPLETED',
  'CANCELLED',
  'REJECTED',
];

export const DISTRIBUTION_PAGE_SIZE = 10;

/** Default editable document series, e.g. `SO-20261019-235959`. */
export function generateSeries(prefix: string, now = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${prefix}-${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}` +
    `-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`
  );
}
